
import "babel-polyfill";
import "isomorphic-fetch"


import lity from './lib/lity.js';
import tippy, {followCursor} from 'tippy.js';

const craftUrl = 'https://aanp.ddev.site';
// const craftUrl = 'https://www.aanpqa.com';

import regeneratorRuntime from "regenerator-runtime";

function isLocked(menuItem){

  const accountLocked = menuItem.accountLock && menuItem.accountLock.length > 0;
  const memberGroupLocked = menuItem.memberGroupLock && menuItem.memberGroupLock.length > 0;
  const memberLock = menuItem.memberLock;
  const accountLocks = menuItem.accountLock;

  if (accountLocked || memberGroupLocked){
    if (memberGroupLocked){
      let userMemberGroupLocks = [];
      for (let i = 0; i < memberGroups.length; i++){
        userMemberGroupLocks.push(memberGroups[i].name);
      }
      var memberGroupIntersect = userMemberGroupLocks.filter(x => menuItem.memberGroupLock.includes(x))


    }
    if (((accountLocked && accountLocks.includes(memberType)) || !accountLocked ) && (!memberGroupLocked || (memberGroupLocked && memberGroupIntersect.length > 0)) || (memberGroupLocked && memberGroupIntersect.length == 0 && memberLock && isCurrentMember))  {
      return 'memberUn';
    }else{
      return 'memberLock';
    }
  }else if (memberLock){
    return true
  }
  return false;
}
function renderMenuItem(menuItem, arrow){
  let menuItemClass = "";
  let menuItemAppend = "";
  if (isLocked(menuItem)) {
    menuItemClass += "linkLocked"
    if (isLocked(menuItem) === 'memberLock') menuItemClass += " linkLocked--retain";
  }
  if (arrow) menuItemAppend = '<span class="menu-arrow icon-caret"></span>';
  return '<a class="' + menuItemClass + '" href="' + menuItem.url + '">' + menuItem.title + menuItemAppend + '</a>';
}

async function loadMenu(){
	const menu = await fetch(craftUrl + '/menu.json');
	const menuJson = await menu.json();
	let menuOutput = [];
	for (let i = 0; i < menuJson.data.length; i += 1) {
    let menuItem = menuJson.data[i];
    menuOutput.push('<li class="has-submenu menu-megaMenu">' + renderMenuItem(menuItem, true));
    if (menuItem.children.length > 0){
      menuOutput.push('<ul class="menu vertical">');
        menuOutput.push('<button class="menu-close show-for-large"><span class="show-for-sr">Close menu</span></button>')
        menuOutput.push('<li class="menu-header show-for-large">' + renderMenuItem(menuItem, true) + '</li>')
        let menuColumnClass = "";
        if (menuItem.children.length > 7) menuColumnClass += "wide";
        menuOutput.push('<li class="menu-column ' + menuColumnClass + '">');
          menuOutput.push('<ul class="menu vertical">');
          for (let j = 0; j < menuItem.children.length; j++){
            menuOutput.push('<li>' + renderMenuItem(menuItem.children[j]) + '</li>');
          }
          menuOutput.push('</ul>');
        menuOutput.push('</li>');

        if (menuItem.callout){
          let button = [];
          if (menuItem.callout.button.memberTypes){
            button = menuItem.callout.button.memberTypes[memberPromotionType];
          }else if (menuItem.callout.button){
            button = menuItem.callout.button;
          }
          menuOutput.push('<li class="menu-callout">');
            menuOutput.push('<div class="menu-callout-content">');
              menuOutput.push('<h2 class="h2">' + menuItem.callout.heading + '</h2>');
              menuOutput.push('<p>' + menuItem.callout.summary + '</p>');
              if (button){
                menuOutput.push('<a href="' + button.url + '" class="button alert small">' + button.text + '</a>');
              }
            menuOutput.push('</div>');
          menuOutput.push('</li>');
        }
      menuOutput.push('</ul>');
    }
		menuOutput.push('</li>')
	}
	if (menuOutput.length > 0){
    menuOutput.push('<li class="hide-for-large"><a href="https://www.aanp.org/contact">Contact Us</a></li>')
		$('#mainNav').html(menuOutput.join('')).attr("data-responsive-menu", "accordion large-dropdown").foundation();
	}
}
async function loadLinks(jsonPath, elem){
	const response = await fetch(jsonPath);
	const responseJson = await response.json();
	let menuOutput = [];

	for (let i = 0; i < responseJson.data.length; i += 1) {
    let menuItem = responseJson.data[i];
    menuOutput.push('<li><a href="'+menuItem.url+'">'+menuItem.title+'</a></li>');
	}
	if (menuOutput.length > 0){
		$(elem).html(menuOutput.join(''));
	}
}

async function loadSocial(){
	const response = await fetch(craftUrl + '/social.json');
	const responseJson = await response.json();

	let menuOutput = [];
	for (let i = 0; i < responseJson.length; i += 1) {
    let menuItem = responseJson[i];
    menuOutput.push('<li><a href="'+menuItem.url+'" target="_blank"><span class="icon-'+menuItem.type+'"></span><span class="show-for-sr">'+menuItem.type+'</span></a></li>');
	}
	if (menuOutput.length > 0){
		$('.social-list').html(menuOutput.join(''));
	}
}


class Show {
  constructor(){
    this.options = {
      elemSelector: '[data-show]',
      activeClass: 'is-active'
    }
  }
  init(){
    this.bindEvents()
  }
  bindEvents(){
    const self = this;
    $(document).on('change', this.options.elemSelector, function(e){
      const { value } = e.target;
      const group = $(this).attr('data-show');
      const $curr = $('[data-' + group + '="' + value + '"]');
      $curr.addClass(self.options.activeClass).removeAttr('disabled')
      $('[data-' + group + ']').not($curr).removeClass(self.options.activeClass).attr('disabled', true)

    })
  }
}

class Pager {
  constructor(){
    this.options = {
      pagerNext: 'pager-next',
      pagerPrev: 'pager-prev',
      buttonContinue: 'pager-continue'
    }
    this.currPage = 0;
    this.$currPage = null
  }
  init(){
    this.setCurrentPage()
    this.bindEvents()
  }
  checkPagerStatus(){
    $('.' + this.options.pagerPrev).attr('disabled',!this.$currPage.prev('.page:not(.is-disabled)').length > 0)
    $('.' + this.options.pagerNext).attr('disabled',!this.$currPage.next('.page:not(.is-disabled)').length > 0)

  }
  setCurrentPage(){
    this.$currPage = $('.page.is-active')
    this.$prevPage = this.$currPage.prev()
    this.$nextPage = this.$currPage.next()
    this.currPage = this.$currPage.index();
  }
  updatePagerIndex(){
    this.setCurrentPage()
    $('[data-page-index]').attr('data-page-index', this.currPage)
  }
  checkRequired(){
    let completed = true

    this.$currPage.find('[required]:not(:hidden)').each(function(){
      // console.log($(this));
      if ($(this).is('[type="radio"]') || $(this).is('[type="checkbox"]')){
        const fieldName = $(this).attr("name");
        if ($('input[name="'+ fieldName + '"]:checked').length === 0){
          return completed = false
        }
      }else{
        if ($(this).val() === ''){
          return completed = false
        }
      }
    })


    return completed
  }

  checkPageDisabled(){

    setTimeout(() => {
      if (this.checkRequired()){
        this.$nextPage.removeClass('is-disabled')
        $('.' + this.options.buttonContinue).removeAttr('disabled')
      }else{
       this.$nextPage.addClass('is-disabled')
       $('.' + this.options.buttonContinue).attr('disabled',true)
      }

    }, 50)
  }

  nextPage(){
    this.$nextPage.addClass('is-active')
    this.$currPage.removeClass('is-active')
    this.scrollTop()
  }
  scrollTop(){
    $('html, body').scrollTop(0);
  }
  bindEvents(){
    const self = this;
    $(document).on('click', '.'+this.options.buttonContinue, function(e){
      e.preventDefault();
      self.nextPage()
      if (!self.$nextPage.hasClass('is-loaded')){
        const pageUrl = self.$nextPage.attr('data-page');
        $.get(pageUrl, function(data) {
          const html = $(data).find('.page.is-active')
          self.$nextPage.replaceWith(html).addClass('is-loaded')
          self.updatePagerIndex()
          self.checkPagerStatus()
          self.checkPageDisabled()
          initTippy()
        });
      }else{
        self.updatePagerIndex()
        self.checkPagerStatus()
        self.checkPageDisabled()
      }

    })
    $(document).on('click', '.'+this.options.pagerNext, function(e){
      e.preventDefault();
      self.nextPage()
      self.updatePagerIndex()
      self.checkPagerStatus()
      self.checkPageDisabled()
    })
    $(document).on('click', '.'+this.options.pagerPrev, function(e){
      e.preventDefault();
      self.$prevPage.addClass('is-active')
      self.$currPage.removeClass('is-active')
      self.scrollTop()
      self.updatePagerIndex()
      self.checkPagerStatus()
      self.checkPageDisabled()
    })
    $(document).on('change', '.page [required]', function(e){
      self.checkPageDisabled()
    })
  }
}

function initTippy(){

  let tippySelector = '[data-tippy-content]:not([data-tippy-content=""]):not([data-tippy-content="false"])';
  let tippies = document.querySelectorAll(tippySelector + ":not([class*=tippy-initialized])");

  tippy(tippies, {
    // placement: "right",
    // // trigger: "click",
    // interactive: true,
    // interactiveDebounce: 50,
    hideOnClick: false,
    plugins: [followCursor],

    followCursor: true,
    // animation: "shift-away",
    arrow: false,
    onMount: function(tippyElem){
      var elem = tippyElem;
      if (!elem.reference.classList.contains("tippy-initialized")){
        if (elem.reference.parentElement){
          elem.reference.parentElement.setAttribute('aria-labelledby','tippy-tooltip')
        }
        elem.popper.setAttribute('id','tippy-tooltip')
        elem.popper.setAttribute('role','tooltip')
        elem.reference.addEventListener('touchstart', function (event) {
          if (elem.state.isVisible){
            elem.setProps({ 'trigger' : 'manual'});

            elem.hide();
          }else{
            elem.setProps({ 'trigger' : 'focus mouseenter'});
            elem.show();
          }
        }, false);
      }
      elem.reference.classList.add('tippy-initialized');
    },
    onHide: function(elem){


      if (elem.reference.parentElement){
        elem.reference.parentElement.removeAttribute('aria-labelledby')
      }
    }
  });
}

$(document).ready(function(){
  loadMenu();
  initTippy();

  const pager = new Pager();
  pager.init();

  const show = new Show();
  show.init();

  loadLinks(craftUrl + '/footer.json', '.footer-nav');
  loadLinks(craftUrl + '/utility.json', '.top-menu .menu');
  loadSocial();
  $('.js-lity').on('click', function(e){
    e.preventDefault();
    const href = $(this).attr("href");
    lity(href, {
      template: '<div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>'
    });

  })
  $('.js-anchor').on('change', function(){
    const self = this;
    const selected = $(this).find(':selected').val();

    if (selected.startsWith("#")){
      const $anchor = $(selected);
      if ($anchor.hasClass('js-lity')){
        const href = $anchor.attr("href");
        lity(href, {
          template: '<div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>'
        });
      }else if ($anchor.hasClass('accordion-item')){
        if (!$anchor.hasClass('is-active')){
          $anchor.find('> a').click();
        }else{
          $('html, body').animate({
              scrollTop: $anchor.offset().top
          }, 400);
        }

      }

      var selectize = self.selectize;
      selectize.clear(true);


    }else{
      window.location.href = selected;
    }
  });
});
